export const extractCollection = (response) => {
  const data = response?.data?.data || response?.data || [];
  if (!Array.isArray(data)) {
    return [];
  }
  return data.map(unwrapEntity);
};

export const unwrapEntity = (entity) => {
  if (Array.isArray(entity)) {
    return entity.map(unwrapEntity);
  }
  if (!entity || typeof entity !== 'object') {
    return entity;
  }

  if ('attributes' in entity && entity.attributes) {
    const { id, attributes } = entity;
    return {
      id,
      ...unwrapObject(attributes),
    };
  }

  if ('data' in entity) {
    return unwrapEntity(entity.data);
  }

  return unwrapObject(entity);
};

const unwrapObject = (obj) => {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }

  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value && typeof value === 'object') {
      acc[key] = unwrapEntity(value);
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});
};

